// Delivery charges in cents (Ireland only) – mirrors backend/delivery.py.
export const SM_TIERS = [[10, 900], [20, 1800], [40, 2700], [60, 3500], [80, 4400], [100, 5200], [130, 6000]];
export const SM_MAX = 8000;
export const LX_TIERS = [[10, 900], [20, 2500], [40, 4800], [60, 6000], [100, 8000]];
const SMALL = ["small", "medium"];

export const individualDelivery = (sizes) => (sizes.some((s) => !SMALL.includes(s)) ? 1800 : 800);
export const tierLabel = (tiers, i) => `${i === 0 ? 1 : tiers[i - 1][0] + 1}–${tiers[i][0]}`;
